import { render } from "./areas-grid.vue?vue&type=template&id=a5b0ffb4"
import script from "./areas-grid.vue?vue&type=script&setup=true&lang=js"
export * from "./areas-grid.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/administration/roles/areas-grid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5b0ffb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5b0ffb4', __exports__)) {
    api.reload('a5b0ffb4', __exports__)
  }
  
  module.hot.accept("./areas-grid.vue?vue&type=template&id=a5b0ffb4", () => {
    api.rerender('a5b0ffb4', render)
  })

}


export default __exports__